import { render, staticRenderFns } from "./GiftingRemindersCard.vue?vue&type=template&id=397a03b9&scoped=true&"
import script from "./GiftingRemindersCard.vue?vue&type=script&lang=js&"
export * from "./GiftingRemindersCard.vue?vue&type=script&lang=js&"
import style0 from "./GiftingRemindersCard.vue?vue&type=style&index=0&id=397a03b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397a03b9",
  null
  
)

export default component.exports